import { JsonForms } from '@jsonforms/react';

import { renderers } from './renderers';
import {
  JsonFormsRendererRegistryEntry,
  UISchemaElement,
} from '@jsonforms/core';

import { useRef } from 'react';
import { useDynamicFormContext } from './DynamicFormContext';

type Props = {
  customRenderers?: JsonFormsRendererRegistryEntry[];
  refProps?: any;
};

export const DynamicForm = ({
  customRenderers = [],
}: Props) => {
  const { formData, schema, uiSchema } = useDynamicFormContext();
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <div
      className="tru-dynamic-form"
      ref={ref}>

      <JsonForms
        data={formData}
        schema={schema}
        uischema={uiSchema as UISchemaElement}
        renderers={[...renderers, ...customRenderers]}
        validationMode="NoValidation"
      />
    </div>
  );
};
